/** ***********************************************************************
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ************************************************************************* */

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import uuid from 'uuid';
import { FrameSection, FrameItem } from '@ccxi/ccxi-shared-components/src/HeaderFooterBase';
import { PDPAnalytics } from '../../../../analytics';
import { PDP_SECTION, PDP_ACTION } from '../../../../utils/pdpUtils/pdpEnums';
import TranslationUtil from '../../../../utils/translation';

const { getMessage } = TranslationUtil;
class OtherPlatforms extends Component {
    onAppClick(e, appObj) {
        const { PDPDataObject: { actionHandlerCallback } } = this.props;
        const { sectionId } = this.sectionData;
        const guid = uuid.v4();

        PDPAnalytics.otherPlatformClick(appObj, guid, sectionId);
        const actionParam = {
            actionObject: appObj,
            guid,
        };
        actionHandlerCallback(e, sectionId, appObj.actionId, actionParam);
    }

    get sectionData() {
        const { PDPDataObject, appsList } = this.props;
        return this.validateAndProcessData(PDPDataObject, appsList);
    }

    validateAndProcessData({ app }, appsList) {
	    const filteredApps = appsList
	        .filter(appObject => (appObject.appLineage && appObject.appLineage === app.appLineage
				&& appObject.sapcode !== app.sapcode));
        const appList = filteredApps
            .map(appModel => ({ actionId: PDP_ACTION.APP_CLICK, app: appModel }));

	    if (!appList.length) {
	        return null;
	    }
	    return {
	        sectionId: PDP_SECTION.OTHER_PLATFORMS,
	        appList,
	    };
    }

    render() {
        if (this.sectionData) {
            const appListing = [];
            const { appList } = this.sectionData;
            appList.forEach((appObj) => {
                const {
                    appFamilyName, iconURL, platform, sapcode,
                } = appObj.app;
                appListing.push(
                    <FrameSection
                        key={`other-platform-${sapcode}`}
                        tabIndex="0"
                        role="link"
                        aria-label={`${appFamilyName} ${platform}`}
                        position="left"
                        className="other-platforms-app-row"
                        onClick={(e) => { this.onAppClick(e, appObj); }}
                        onKeyDown={(e) => {
                            if (e.keyCode === 13) {
                                this.onAppClick(e, appObj);
                            }
                        }}>
                        <FrameItem>
                            <img alt={appFamilyName} className="other-platform-app-icon" src={iconURL} />
                        </FrameItem>
                        <FrameItem>
                            <div className="app-title">
                                <div className="app-name">{appFamilyName}</div>
                                <div className="app-platform">
                                    {getMessage(`ccx.app.platform.${platform}`)}
                                </div>
                            </div>
                        </FrameItem>
                    </FrameSection>
                );
            });
            return (
                <div className="other-platforms right-panel-compt">
                    <h1 className="other-platforms-heading">{getMessage('ccx.pdp.other-platforms.section-name')}</h1>
                    {appListing}
                </div>
            );
        }
        return null;
    }
}

export default observer(OtherPlatforms);
